import type { CalendarViewType } from "@/types/dashboard"

import ActivityCalendarMonthlyWidget from "./ActivityCalendarMonthlyWidget"
import ActivityCalendarWeeklyWidget from "./ActivityCalendarWeeklyWidget"
import ActivityScheduleWidget from "./ActivityScheduleWidget"

interface ActivityCalendarWidgetProps {
  view?: CalendarViewType
}

export default function ActivityCalendarWidget({ view = "monthly" }: ActivityCalendarWidgetProps) {
  switch (view) {
    case "weekly":
      return <ActivityCalendarWeeklyWidget />
    case "daily":
      return <ActivityScheduleWidget />
    default:
      return <ActivityCalendarMonthlyWidget />
  }
}
